import { useEffect, useState, useRef } from "react";
import MaterialTable, { MTableToolbar } from "material-table";
import {
    Box,
    Grid,
    FormControl,
    Button,
    CircularProgress,
    Typography,
    IconButton,
    Tooltip,
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    DialogActions,
   
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import Popup from "../../../Base/views/Popup";
import { GetWageReportAction, GetWageReportNotProcessedAction } from "../../../../../store/Finance/Reports/Action";
import { GenerateWageReportHelper } from "../../helper/Reports/GetWageReportHelper";
import { formatPayDatePeriod } from "../../../Base/helper/baseFunctions";
import { AddMenuHeadingAction } from "../../../../../store/Menu/Action";
import history from "../../../../../history";
import { toast } from "react-toastify";
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import PlayCircleFilledIcon from '@mui/icons-material/PlayCircleFilled';
import { GetCustomPayableEmployeeHelper, onholdEmployeeHelper } from "../../helper/Employee/EmployeeTemplateHelper";
import EmployeePayroleTemplate from "../Employee/EmployeePayroleTemplate";
import { GetPayrollTileViewAction } from "../../../../../store/Finance/PayrollManagement/Action";
import CloseIcon from "@mui/icons-material/Close";
import { grey, red } from "@mui/material/colors";
import SelectableMultiSelect from "../../../Base/views/SelectableMultiSelect";

const MyEmployeePayroleReportsNotProcessed = ({selectedYear, selectedMonth, readOnly, paydate, worklocationData, handleWorkLoacation}) => {
    const dispatch = useDispatch();
    const { wage_report_notprocessed_data, isLoading } = useSelector(
        (state) => state?.FinanceReducer.WageReportsReducer
    );
    const { work_hours_data } = useSelector(state => state.LeaveReducer?.WeekOffConfigureReducer);
    const [openwarningPopup, setWarningOpenPopup] = useState(false);
    const [navigateSection, setNavigateSection] = useState("");
    const [navigateId, setNavigateId] = useState("");
    const [msg, setMsg] = useState("");
    const [, setAnchorE] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [isLoadingbtn, setIsLoadingbtn] = useState(false);
    const [loading1, setLoading1] = useState(null);
    const [currentData, setCurrentData] = useState("")
    const [openTemplate, setOpenTemplate] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const tableRef = useRef(null);
    const [payableFlag, setPayableFlag] = useState(false);
    const [payableDays, setPayableDays] = useState(0)
    const [payableDayError, setPayableDayError] = useState("");
    const [filters, setFilters] = useState({
            ats_work_location_id: []
        });
    useEffect(() => {
        const f_month = parseInt(selectedMonth, 10).toString();
        const locationPayload = JSON.stringify((filters?.ats_work_location_id || [])?.map((item) => ({ ats_work_location_id: item?.work_location_id })));
        dispatch(GetWageReportNotProcessedAction({ month: f_month, year: String(selectedYear),
            ats_work_location_json: (filters?.ats_work_location_id || [])?.length > 0 ? locationPayload : null,
         }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, filters]);

    const handleSelect = (rows, dataClicked) => {
        const isSelectAll = dataClicked === undefined;
        if (isSelectAll) {
            // Toggle: if any eligible rows already selected → deselect all
            if (selectedRows.length > 0) {
                if (tableRef.current) {
                    const dm = tableRef.current.dataManager;
                    dm.data.forEach(row => { row.tableData.checked = false; });
                    tableRef.current.setState(dm.getRenderState());
                }
                setSelectedRows([]);
                return;
            }
            // None selected → select all eligible, uncheck disabled ones
            const eligible = rows.filter(r => r.reason === "Employee ready for payroll generation");
            if (rows.length > eligible.length && tableRef.current) {
                const dm = tableRef.current.dataManager;
                dm.data.forEach(row => {
                    if (row.reason !== "Employee ready for payroll generation") {
                        row.tableData.checked = false;
                    }
                });
                tableRef.current.setState(dm.getRenderState());
            }
            setSelectedRows(eligible);
        } else {
            // Individual row click — just filter eligible
            const eligible = rows.filter(r => r.reason === "Employee ready for payroll generation");
            setSelectedRows(eligible);
        }
    };
    const handleGenerateClicked = () => {
        if (!work_hours_data) {
            setMsg("Work Hour configuration is required for payroll settings. Please configure it now.");
            setNavigateSection("General");
            setNavigateId("4");
            setWarningOpenPopup(true);
        } else {
            setIsLoadingbtn(true);
            const id = selectedRows?.map(item => item?.employee_fk);
            GetCustomPayableEmployeeHelper({
                employee_fk:  id?.length ? `{${id}}` : null,
            }).then((res) =>{ 
                if(res?.data?.statuscode === 200) {
                    setPayableDays(0)
                    setPayableFlag(res?.data?.data?.[0]?.payroll_custom_payable_contractual_employee)  
                    setAnchorE(null);
                    setOpenDialog(true);
                    setIsLoadingbtn(false);
                } else {
                    setIsLoadingbtn(false);
                    toast.error("Something went wrong")
                }
            })
        }
    };
    const handleNavigate = (menu, value) => {
        sessionStorage.setItem("selectedMenu", menu);
        dispatch(AddMenuHeadingAction({ heading: menu }));
        history.push({
            pathname: "/settings",
            state: { click_event: value },
        });
    };
    const handleGenerate = () => {
        if (payableDays === "" || payableDays === null ){
            setPayableDayError("Payable days is required.")
            return;
        } else if (!payableDays?.toString().match(/^\d{1,2}(\.\d{1,2})?$/)) {
            setPayableDayError("Invalid payable days.")
            return;
        } else if (Number(payableDays) <= 0 && payableFlag) {
            setPayableDayError("Payable days must be greater than 0.");
            return;
        } else {
            setPayableDayError("")
        }
        setIsLoadingbtn(true);
        const f_month = parseInt(selectedMonth, 10).toString();
        const id = selectedRows.map(item => item.employee_fk);
        GenerateWageReportHelper({
            employee_id: id?.length ? `{${id}}` : null,
            month: f_month,
            year: String(selectedYear),
            custom_payable_days: payableDays
        }).then((res) => {
            if (res?.data?.statuscode === 200) {
                dispatch(GetWageReportNotProcessedAction({ month: f_month, year: String(selectedYear) }));
                dispatch(GetWageReportAction({ month: f_month, year: String(selectedYear) }));
                dispatch(GetPayrollTileViewAction({ year: String(selectedYear) }))
                setSelectedRows([]);
            }
            else if (res?.data?.statuscode === 500) {
                toast.error("Something went wrong")
            }
            setIsLoadingbtn(false);
        });
        setOpenDialog(false);
    };

    const handleRemoveHold = (rowData) => {
        setLoading1(rowData?.employee_id); 
        try {
            onholdEmployeeHelper({
                employee_id: rowData?.employee_id,
                payroll_onhold: false,
                resume_payroll : true,
                name: rowData?.name
            }).then((res) => {
                if (res?.data?.statuscode === 200) {
                    const f_month = parseInt(selectedMonth, 10).toString();
                    dispatch(GetWageReportNotProcessedAction({ month: f_month, year: String(selectedYear) }));
                }
            });
        } finally {
            setTimeout(() => {
                setLoading1(null);
            }, 500);
        }
    }

    
    const handleOpenPayrollSetup = (rowData) => {
        setCurrentData(rowData);
        setOpenTemplate(true);
    };
    const handleFilterChange = (event, value) => {
        if (["ats_work_location_id"].includes(event)) {
        if (value) {
            setFilters({ ...filters, [event]: value });
        } else {
            setFilters({ ...filters, [event]: "" });
        }
        }
    }
    const tableTitle = (<Box>
                <Typography variant="h6" fontWeight={600}>
                    Not Processed Employee
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    New employees not included in the current payroll cycle
                </Typography>
                </Box>)
    return (
        <Box sx={{ overflowY: "auto"}}>
            <Box sx={{ m: 1 }}>
                <Grid sx={{ display: "flex", justifyContent: "space-between" }} container columnSpacing={1} mb={1} mt={1}>
                    <FormControl>
                    </FormControl>
                    <div>
                        { (selectedRows?.length > 0) && !readOnly && (
                            <Button
                                onClick={handleGenerateClicked}
                                className="mpl-primary-btn"
                                disabled={isLoadingbtn}
                                startIcon={isLoadingbtn ? <CircularProgress size={18} color="inherit" /> : null}
                                
                            >
                                Generate Payroll
                            </Button>
                        )}
                    </div>
                </Grid>
            </Box>

            <Box>
                <MaterialTable
                    tableRef={tableRef}
                    isLoading={isLoading}
                    columns={[
                        { title: "Employee No", field: "employee_no", cellStyle: {padding: "0px 0px 0px 20px"}, headerStyle: {padding: "5px 0px 5px 20px"} },
                        { title: "Employee Name", cellStyle: {padding: "0px 0px 0px 50px"}, headerStyle: {padding: "5px 0px 5px 50px"}, field: "name" },
                        { title: "Work Location", cellStyle: {padding: "0px 0px 0px 53px"}, headerStyle: {padding: "5px 0px 5px 50px"}, field: "work_location_name",
                            render: (rowData) => rowData?.work_location_name || "N/A"
                        },
                        { title: "Reason", cellStyle: {padding: "0px 0px 0px 50px"}, headerStyle: {padding: "5px 0px 5px 50px"},field: "reason" },
                         {
                            title: "Actions",
                            field: "actions",
                            width: "10%",  
                            hidden: readOnly,
                            sorting: false,
                            cellStyle: {padding: "0px 0px 0px 20px"}, 
                            headerStyle: {padding: "5px 0px 5px 20px"},
                            render: (rowData) => {
                                if (rowData?.reason === "Employee ready for payroll generation") {
                                    return null;
                                }
                                return (
                                    <Box display="flex" gap={1} alignItems="center" height="100%">
                                        {rowData?.reason === "Payroll is on hold" && (
                                          loading1 === rowData?.employee_id ? (
                                             <CircularProgress size={24} /> 
                                          ) : ( 
                                            <Tooltip title="Resume payroll">
                                            <IconButton
                                                    onClick={() => handleRemoveHold(rowData)}
                                                    color="primary"
                                                    sx={{
                                                        padding: "0px", 
                                                    }}
                                                >
                                                    <PlayCircleFilledIcon fontSize="14px"/>
                                                </IconButton>
                                            </Tooltip>
                                            )
                                        )}
                                        {rowData.reason === "Payroll setup not complete" && (
                                            <Tooltip title="Complete payroll setup">
                                                <IconButton
                                                    onClick={() => handleOpenPayrollSetup(rowData)}
                                                    color="primary"
                                                    sx={{
                                                        padding: "0px", 
                                                    }}
                                                >
                                                    <BusinessCenterIcon fontSize="14px"/>
                                                </IconButton>
                                            </Tooltip>
                                        )}
                                    </Box>
                                );
                            },
                        },
                    ]}
                    data={wage_report_notprocessed_data}
                    options={{
                        maxBodyHeight: 320,
                        minBodyHeight: 320,
                        rowStyle: { fontSize: "13px", height:"35px" },
                        headerStyle: { padding: "5px 10px 5px 13px", fontWeight: "bold" },
                        sorting: true,
                        search: true,
                        searchFieldAlignment: "right",
                        searchAutoFocus: false,
                        filtering: false,
                        paging: true,
                        pageSizeOptions: [25, 50],
                        pageSize: 25,
                        selection: !readOnly,
                        selectionProps: (rowData) => ({
                            disabled: rowData.reason !== "Employee ready for payroll generation",
                        }),
                        actionsColumnIndex: -1,
                        showSelectAllCheckbox: !readOnly,
                        showTextRowsSelected: true,
                        grouping: false,
                        columnsButton: false,
                        showTitle: true,
                    }}
                    onSelectionChange={handleSelect}
                    onChangePage={(page) => setCurrentPage(page)} 
                    page={currentPage} 
                    title={""} 
                    components={{
                        Toolbar: (props) => (
                            <Box sx={{ width: "full", display: "flex", flexDirection: { xs: "column", sm: "row" }, flexGrow: 1 }}>
                                <Box
                                    sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    backgroundColor: "#f3edfd",
                                    padding: "0px 0px 0px 20px",
                                    flexGrow: 1,
                                    minHeight: "48px !important",
                                    }}
                                >
                                <Box>
                                    <Typography variant='h6'>
                                        {tableTitle}
                                    </Typography>
                                </Box>
                                <Box sx={{width: "210px", display: "flex", alignItems: "center", pt: 0.5}}>
                                    <SelectableMultiSelect
                                        multiple
                                        label="Work Location"
                                        placeholder="Select Location"
                                        value={filters?.ats_work_location_id}
                                        loading={handleWorkLoacation}
                                        fieldLabel="work_location_name"
                                        name="ats_work_location_id"
                                        size="small"
                                        onChangeEvent={handleFilterChange}
                                        data={worklocationData}
                                        menuHeight={150} // optional
                                    />
                                </Box> 
                                </Box>
                                    <Box
                                    sx={{
                                        "& .MuiToolbar-root": {
                                        padding: "12px 16px !important",
                                        margin: "0 !important",
                                        minHeight: "48px !important",
                                        },
                                        "& .MuiFormControl-root": {
                                        margin: "0 !important",
                                        },
                                        "& .MuiInputBase-root": {
                                        marginLeft: "-20px !important",
                                        }
                                    }}
                                    >
                                        <MTableToolbar {...props} />
                                    </Box>
                                </Box>
                        ),
                    }}
                />
            </Box>
{/* Generate payroll confirmation dialog */}
            <Dialog open={openDialog} maxWidth="xs" fullWidth >
                <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    Generate Payroll
                    <IconButton onClick={() =>setOpenDialog(false)} size="small">
                    <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography variant="body1" sx={{fontWeight: 600, color: "inherit"}}>
                            {`Payroll will be generated from ${formatPayDatePeriod(paydate)}. Are you sure you want to continue?`}
                            </Typography>
                        </Grid>
                        { payableFlag && ( <Grid key="payday" item xs={12}>
                        <Typography variant="body2" sx={{ mb: 1.5, color: "text.secondary" }}>
                            Some employees is configured with the Payable Days template. Please enter the number of payable days to calculate salary.
                        </Typography>
                        <FormControl fullWidth >
                            <TextField
                                autoFocus
                                size="small"
                                value={payableDays}
                                onChange={(e) => {setPayableDays(e.target.value); setPayableDayError("")}}
                                variant="outlined"
                                required
                                label="Payable Days"
                                name="custom_payable_days"
                                type="number"
                                placeholder="00.00"
                                sx={{
                                    "& input::placeholder": {
                                    color: "#B0B0B0",
                                    },
                                }}
                                    {...(payableDayError && {
                                    error: true,
                                    helperText: payableDayError,
                                    })}
                                />
                        </FormControl>
                        </Grid>)}
                    </Grid>
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2 }}>
                    <Box item xs={12} sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 1 }}>
                        <Button
                            variant="outlined"
                            size="small"
                            onClick={() => setOpenDialog(false)}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="outlined"
                            size="small"
                            onClick={handleGenerate}
                            sx={{
                                ":hover": { color: grey[50], background: red[700] },
                                color: grey[50],
                                background: red[500],
                            }}
                        >
                            Yes
                        </Button>
                </Box>
                </DialogActions>
            </Dialog>
            <Popup
                fullWidth={true}
                maxWidth="md"
                title="Warning"
                openPopup={openwarningPopup}
                setOpenPopup={setWarningOpenPopup}
            >
                <Typography sx={{ pt: 2, pb: 2, textAlign: "center" }} variant="h5">
                    ⚠️ {msg}
                </Typography>

                <Box display="flex" justifyContent="center" gap={2} sx={{ mt: 2 }}>
                    <Button
                        onClick={() => handleNavigate(navigateSection, navigateId)}
                        className="mpl-primary-btn"
                    >
                        Configure Now
                    </Button>
                </Box>
            </Popup>
            <Popup
                maxWidth="sm"
                fullWidth={true}
                title={`Payroll Configuration - ${currentData?.name}`}
                openPopup={openTemplate}
                setOpenPopup={setOpenTemplate}
            >
                <EmployeePayroleTemplate filters={{month_year: `${selectedYear}-${selectedMonth}`}} empNotProcessed={true} createEmp={false} setOpenTemplate={setOpenTemplate} openTemplate={openTemplate} currentData={currentData} />
            </Popup>
        </Box>
    );
};

export default MyEmployeePayroleReportsNotProcessed;